
import {Options, Vue} from 'vue-class-component';
import {Appointment} from "@/data/appointments";
import {Course} from "@/data/course";
import {RecordIdentifier} from "@/data/global";
import {formatTime} from "@/utils/helpers";
import apiConfig from "@/config/api";
import AppointmentDetailModal from "@/components/modals/AppointmentDetailModal.vue";
import CourseEnrollmentModal from "@/components/modals/CourseEnrollmentModal.vue";
import {MonthNumbers} from "luxon";

import {DateTime} from "luxon";

import {Calendar} from 'v-calendar';


const now = DateTime.now();
// const nowMonth = now.getMonth();
// const nowYear = now.getFullYear();
const minDate = now.set({day: 1});
const maxDate = minDate.plus({month: 6}).minus({day: 1}); // see 5-6 months into the future

@Options({
    props: {
        appointments: {
            type: Array,
            required: true,
        },
        visibleMonths: {
            type: Number,
            required: false,
        },
    },
    components: {
        CourseEnrollmentModal,
        AppointmentDetailModal,
        Calendar,
    },
    watch: {},
    emits: ['load-month']
})
export default class AppointmentsCalendar extends Vue {
    appointments!: Appointment[]

    // nowMonth = nowMonth
    // nowYear = nowYear

    loadedMonths: string[] = []

    currentDisplayedMonth: { year: number; month: MonthNumbers } = {
        year: DateTime.now().year,
        month: DateTime.now().month as MonthNumbers
    };

    currentModalAppointment: Appointment | null = null
    currentModalCourse: Course | null = null
    modalAppointmentShown = false
    modalCourseShown = false

    minDate = minDate

    // maxDate = maxDate
    get maxDate() {
        return this.appointments.reduce<DateTime>((max, appointment) => {
            const appointmentStart = DateTime.fromISO(appointment.start);
            return appointmentStart > max ? appointmentStart : max;
        }, minDate);
    }

    masks = {
        weekdays: 'WWW',
    }

    get attributes() {
        return [
            {
                key: 'today',
                highlight: true,
                dates: new Date(),
            },
            ...this.appointmentAttributes,
        ];
    }

    get appointmentAttributes() {
        return this.appointments.map(appointment => {
            const startDate = new Date(appointment.start);
            const endDate = new Date(appointment.end);
            const startTimeHuman = formatTime(startDate);
            const endTimeHuman = formatTime(endDate);
            const startDateHuman = this.formatStartDate(startDate);

            // Debug: Log the actual structure of the location data
            if (appointment?.course?.location) {
                console.log('Location data:', JSON.stringify(appointment.course.location));
            }

            return {
                id: 'appointment-' + appointment.id,
                dates: startDate,
                customData: {
                    type: 'appointment',
                    id: appointment.id,
                    title: `${startTimeHuman} – ${endTimeHuman} Uhr`,
                    subtitle: appointment?.course?.course_type.name,
                    color: appointment?.course?.color,
                    class: 'text-white',
                    startDate: startDateHuman,
                    mode: appointment?.course?.mode,
                    location: appointment?.course?.location,
                    // appointment,
                },
            };
        });
    }

    formatStartDate(date: string | Date): string {
        const options = {year: 'numeric', month: '2-digit', day: '2-digit'};
        const formattedDate = new Date(date).toLocaleDateString('de-DE', options);
        return formattedDate;
    }

    onMonthChange({year, month}: { year: number, month: number }) {
        this.$emit('load-month', {year, month})
        this.currentDisplayedMonth = {year, month: month as MonthNumbers};
    }

    onAppointmentClick(appointmentId: RecordIdentifier, attr: any) {
        const appointment = this.appointments.find(appointment => appointment.id == appointmentId);

        if (appointment?.course?.mode === 1) { // @TODO: Closed enum
            this.currentModalCourse = appointment.course || null;
            this.modalCourseShown = true;
        } else {
            this.currentModalAppointment = appointment || null;
            this.modalAppointmentShown = true;
        }
    }


    get hasAppointmentsInDisplayedMonth() {
        return this.appointments.some(appointment => {
            const appointmentDate = DateTime.fromISO(appointment.start);
            return (
                appointmentDate.year === this.currentDisplayedMonth.year &&
                appointmentDate.month === this.currentDisplayedMonth.month
            );
        });
    }

    get assetsBaseUrl() {
        return apiConfig.frontendAssetsUrl;
    }

    // created() {}

    // mounted() {}
}


